import { lowellConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function LowellPage() {
  return <CityPageTemplate config={lowellConfig} />;
}